import axios from 'axios';
import { useMutation, queryCache } from 'react-query';
import { backendURL } from '../App';

export async function importCompetensionsExcel(anketaId: number, file: File) {
  const data = new FormData();
  data.append('file', file);
  data.append('anketa_id', String(anketaId));
  const res = await axios({
    method: 'post',
    url: `${backendURL}competentions/import/`,
    headers: {
      Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return res.data;
}

export default function useImportCompetensionsExcelMutation(anketaID: string) {
  return useMutation((file: File) => importCompetensionsExcel(Number(anketaID), file), {
    onSuccess: () => {
      queryCache.invalidateQueries(['competensionsData', anketaID]);
    },
  });
}
